import { Injectable } from '@angular/core';
// import * as $ from 'jquery';
// import * from 'bootstrap';
declare var FB: any;
declare var $ : any;
// import datepicker from 'jqueryui';

declare var jQuery: any;
declare var gtag: any;

@Injectable({
  providedIn: 'root'
})
export class CustomjsService {

  constructor() { }

    customFormJS() {

        // console.log('CUSTOM JS INCLUDED');
        $('.form-group input').change(function () {
            // console.log('Change INput')
            if ($(this).val() != '') {
                $(this).addClass('filled');
            } else {
                $(this).removeClass('filled');
            }
        });

        $('.form-group input').each(function () {
            if ($(this).val() != '') {
                $(this).addClass('filled');
            } else {
                $(this).removeClass('filled');
            }
        });

        $('.form-group select').change(function () {
            // console.log('Change INput')
            if ($(this).val() != '') {
                $(this).addClass('filled');
            } else {
                $(this).removeClass('filled');
            }
        });

        $('.form-group select').each(function () {
            if ($(this).val() != '') {
                $(this).addClass('filled');
            } else {
                $(this).removeClass('filled');
            }
        });

        $('.form-control').focus(function () {
            $(this).parent().addClass('focused');

        }).blur(function () {
            $(this).parent().removeClass('focused');
        });
    }

    mobilejs() {
        $(function () {
            // console.log('here is mobile js loaded');
            $('#stores ul li').click(function () {
                // console.log('here is mobile js loaded');
                $('.mobileview-productlisting').css(
                    {
                        'transform': 'translate(0%)',
                        'transition': 'all linear 0.2s'
                    }
                );
            });
            $('.close-productListing-btn').click(function () {
                $('.mobileview-productlisting').css(
                    { 'transform': 'translate(100%)' }
                );
            });

        });

        $(function () {
            (<any>$('.calendar')).datepicker({ });
        });

    }



    submitFB(): any {
        // console.log("submit login to facebook");
        // FB.login();
        FB.login((response)=>
        {
            // console.log('submitLogin',response);
            if (response.authResponse)
            {
                // console.log('Sucess');
                // console.log(response.authResponse);
                if (response.status === 'connected') {
                    let data = {
                        status: response.status,
                        accessToken: response.authResponse.accessToken
                    }

                    return data;
                }
            }
            else
            {
                let data: object;
                if (response.status === 'unknown') {
                    // console.log('Facebook Login Closed');
                    data = {status: 'unknown', accessToken: null};
                } else {
                    // console.log('User login failed');
                    data = {status: 'failed', accessToken: null};
                }

                return data;
            }
        },{scope: 'public_profile, email'});
        // console.log('Function Complete')
    }

    animateScroll(hash, offset=100) {
        var hash = hash;

        $('html, body').animate({
            scrollTop: $(hash).offset().top - offset
        }, 800);
    }

    scrollToTop() {
        window.onscroll = function() {
            if (window.pageYOffset > 300) {
                $('#fixedScroll').css('display', 'block');
            } else {
                $('#fixedScroll').css('display', 'none');
            }
        }
    }

    showFlashMsg() {
        // $('#flash-message').show();
        $('.toast').toast('show');
        // console.log('SHOW');
    }

    hideFlashMsg() {
        // $('#flash-message').hide();
        // console.log('HIDE');
        // console.log($('#flash-message'));
    }

    hideFlashMsgAfter2s() {
        // setTimeout(function() {
        //     $('#flash-message').hide();
        // }, 2000);
    }

    checkIfVisible(): boolean {
        // if ($('#flash-message').is(':visible')) {
        //     return true;
        // }
        return false;
    }

    showToastMsg() {
        $('.toast').toast('show');
    }

    closeAuthencationPopupMsg() {
        setTimeout(function() {
            $('#closeMsg').click();
        }, 5000);
    }

    loadSlider() {
        let slide1 = true;
        let slide2 = true;
        let slide3 = true;
        setTimeout(function() {
            $('.ad-banner-slider div:first-child()').slick({
                arrows: false,
                autoplay: false,
                infinite: true,
                lazyLoad: 'ondemand',
                dots: true,
                fade: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplaySpeed: 10000,
                pauseOnHover: true,
                pauseOnDotsHover: true,
                // centerMode: true,
                dotsClass: 'slick-dots',
                useCSS: true
            })
        },10)
        // $('.ad-banner-slider div').on('afterChange', function(event, slick, currentSlide){
        //     if (currentSlide === 0 && slide1) {
        //         slide1 = false;
        //         gtag('event', 'view_promotion', {
        //             "promotions": [
        //               {
        //                 "id": "375_Park",
        //                 "name": "Scapegrace"
        //               }
        //             ]
        //         });
        //     } else if (currentSlide === 1 && slide2) {
        //         slide2 = false;
        //         gtag('event', 'view_promotion', {
        //             "promotions": [
        //               {
        //                 "id": "375_Park",
        //                 "name": "Sobieski"
        //               }
        //             ]
        //         });
        //     } else if (currentSlide === 2 && slide3) {
        //         slide3 = false;
        //         gtag('event', 'view_promotion', {
        //             "promotions": [
        //               {
        //                 "id": "375_Park",
        //                 "name": "Marie Brizard"
        //               }
        //             ]
        //         });
        //     }
        // });
    }

    nonLoginCouponPopUp() {
        setTimeout(function() {
            $('#addDiscountCouponDialog').click();
        }, 3000);
    }

    searchPop(value) {

        if (value === 'close') {
            if ($('.searchResult').hasClass('show')) {
                // console.log('remove')
                $('.searchResult').removeClass('show');
                // $('#searchDesktop').val("");
            }
            if ($('.searchMobileResult').hasClass('show')) {
                $('.searchMobileResult').removeClass('show')
                // $('#searchMobile').val("");
            }
        } else if (value === 'open-desktop') {
            $('.searchResult').addClass('show');
        } else if (value === 'open-mobile') {
            $('.searchMobileResult').addClass('show');
        } else if (value === 'close-delay') {
            // console.log('delay');
            setTimeout(function() {
                // console.log('delay2');
                $('.searchResult').removeClass('show');
            },4000);
        }

    }

    showShippingModal() {
        if (localStorage.getItem('shippingModal') === 'false' || !localStorage.getItem('shippingModal')) {
            $('#checkShipping').click()
        }

    }

    showMobileFilter(type) {
        if (type === 'open') {
            $('#accordmobile').css('right','0px');
        } else if (type === 'close') {
            $('#accordmobile').css('right','');
        }
    }

    addToCartLoading(slug, isAdding) {
        if (isAdding) {
            console.log('is adding')
            $('#'+slug).html("ADDING <i class='fa fa-pulse fa-spinner' style='margin-left:10px'></i>")
            $('#mobile'+slug).html("ADDING <i class='fa fa-pulse fa-spinner' style='margin-left:10px'></i>")
        } else {
            console.log('added')
            $('#'+slug).html('ADD TO CART');
            $('#mobile'+slug).html('ADD TO CART');
        }
    }

    fixedPaySection() {
      window.onscroll = function() {
        if (window.pageYOffset > 100) {
            $('#fixedPaySection').css('display', 'block');
        } else {
            $('#fixedPaySection').css('display', 'none');
        }

        if (window.pageYOffset > 100) {
          $('#fixedPaySection').addClass('fixedPanel')
        } else {
          $('#fixedPaySection').removeClass('fixedPanel')
        }

        if (window.pageYOffset > 1149) {
          $('#fixedDownScrollBtn').addClass('hide');
        } else {
          $('#fixedDownScrollBtn').removeClass('hide');
        }
      }
    }

    scrollToPaymentMethod() {
        $('[data-toggle="tooltip"]').tooltip({
            template: '<div class="container-width">\
            <p class="line"><span>CSV</span> should have the following column and the order of the column should be as below</p><ul class="inline-head"><li>FirstName</li><li>LastName</li><li>Address</li><li>State</li><li>Zip</li><li>Email</li><li>Phone</li></ul><p class="line">There should not be an comma in the address.</p>\
        </div>'
        })
      $('#fixedPayButton').click(function() {
        $('html, body').animate({
            scrollTop: $("#pmAccordion").offset().top - 500
        }, 2000);
      });
    
    }
    scrollToScheduleOrder() {
        $('html, body').animate({
            scrollTop: $("#scheduleOrder").offset().top - 200
        }, 2000);
    }

    scrollDown() {
      $('#fixedDownScrollBtn').click(function() {
        $('html, body').animate({
            scrollTop: window.innerHeight > 700 ? window.pageYOffset + 800 : window.pageYOffset + 500
        }, 2000);
      });
    }
}
